import React from "react";
import DuplicateGroupTable from "./components/DuplicateGroupTable";

const DuplicatePGsTab = () => (
  <DuplicateGroupTable
    entityType="pgs"
    headingLabel="professional guardians"
    searchPlaceholder="Search by full name / email / business"
  />
);

export default DuplicatePGsTab;
